import BackToSearch from './BackToSearch';

export default BackToSearch;
